<mat-form-field class="nationality-field" appearance="outline">
  <mat-label>Nationality*</mat-label>
  <input matInput [placeholder]="placeholder" [matAutocomplete]="auto" [formControl]="countryControl">
  <mat-autocomplete [displayWith]="displayFn" (optionSelected)="selectCountry.emit($event.option.value._id)" #auto="matAutocomplete">
    <mat-option *ngFor="let state of filteredCountries | async" [value]="state">
      <span>{{state.name}}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
